export { typography } from './variants'
export type { TypographyVariant } from './variants'

export { Heading } from './Heading'
export type { HeadingProps } from './Heading'

export { Text } from './Text'
export type { TextProps } from './Text'

export { Label } from './Label'
export type { LabelProps } from './Label'
